/* Mapping props to a function instead of the actual state helps ensure the data stays up to date. */
function refreshSearch(state) {
	if (state.searchFaculty) {
		return state.searchFaculty;
	}
	return '';
}

function refreshPopupSearch(state) {
	if (state.popupSearch) {
		return state.popupSearch;
	}
	return '';
}

function refreshFilters(state) {
	if (state.filters) {
		return state.filters;
	}
	return null
}

function refreshStudents(state) {
	if (state.students) {
		return state.students;
	}
	return null
}

function refreshCurrentResults(state) {
	if (state.current) {

		return state.current;
	}
	return null
}

function refreshPlaceholder(state){
	if(state.placeholder){
		return state.placeholder
	}
	return 'Search Faculties'
}

function isLoading(state){
	return state.loading
}

export default {
	refreshSearch,
	refreshPopupSearch,
	refreshFilters,
	refreshStudents,
	refreshCurrentResults,
	refreshPlaceholder,
	isLoading,
};
